import { Component, OnInit } from '@angular/core';

import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

import { ActivatedRoute, Router } from '@angular/router';

import { GurdServiceService } from 'src/app/Service/gurd-service.service';

import { NotificationService } from 'src/app/Service/notification.service';

import { OtherService } from 'src/app/Service/other.service';

import { Meta } from '@angular/platform-browser';

import axios from 'src/app/Service/axios';

declare let $: any;

@Component({

  selector: 'app-transit-performance',

  templateUrl: './transit-performance.component.html',

  styleUrls: ['./transit-performance.component.css']

})

export class TransitPerformanceComponent implements OnInit {

  lstCars = [];

  lstRoutes = [];

  lst_Reports = [];

  lst_Search = [];

  lst_GeoFence = [];

  lstMobileType = [];

  iTripTime: number = 0;

  iStops: number = 0;

  iStopsTime: number = 0;

  mdl_Search: FormGroup = this.FormBuilder.group({

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    ID: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    strSDate: new FormControl(''),

    strEDate: new FormControl(''),

    strUnitID: new FormControl(''),

    iSDGeoFence: new FormControl('-1'),

    iSGeoFence: new FormControl('-1'),

    iDGeoFence: new FormControl('-1'),

    tiResultTrip: new FormControl('-1'),

    tiMobileType: new FormControl('-1'),

    tiTripStatus: new FormControl('-1'),

    tiLoadImportance: new FormControl('-1'),

  });

  constructor(

    private _tooltip: NotificationService,

    private FormBuilder: FormBuilder,

    private router: Router,

    private route: ActivatedRoute,

    private gurdService: GurdServiceService,

    private _other: OtherService,

    private metaService: Meta

  ) { }

  ngOnInit(): void {

    this.getGeoFence();

    this.getMobileType();

    this.getCars();

    this.getRoutes();

  }

  getMobileType = async () => {

    let model = this.mdl_Search.value;

    this._other.Showspinner()

    let res = JSON.parse((await axios.post(`GetMobileType_List`, this._other.stringNumberToNumber(model))).data.toString());

    this._other.nonespinner();

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lstMobileType = res;

  }

  getGeoFence = async () => {

    let model = this.mdl_Search.value;

    this._other.Showspinner()

    let res = JSON.parse((await axios.post(`Radyab_GeoFence`, this._other.stringNumberToNumber(model))).data.toString());

    this._other.nonespinner();

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lst_GeoFence = res;

  }

  getCars = async () => {

    let model = this.mdl_Search.value;

    this._other.Showspinner()

    let res = (await axios.post(`FleetYar_Car_List_New`, this._other.stringNumberToNumber(model))).data;

    this._other.nonespinner();

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lstCars = res;

  }

  getRoutes = async () => {

    let model = this.mdl_Search.value;

    this._other.Showspinner()

    let res = JSON.parse((await axios.post(`TransitRoute_List`, this._other.stringNumberToNumber(model))).data.toString());

    this._other.nonespinner();

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lstRoutes = res;

  }

  search_Report = async () => {

    let model = this.mdl_Search.value;

    this._other.Showspinner()

    let res = JSON.parse((await axios.post(`Transit_Trip_Report`, this._other.stringNumberToNumber(model))).data.toString());

    this._other.nonespinner();

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lst_Reports = res;

    this.lst_Search = res;

    this.iTripTime = 0;

    this.iStops = 0;

    this.iStopsTime = 0;

    this.lst_Reports.forEach((el: any) => {

      this.iTripTime += el.iResultTime;

      this.iStops += el.iStops;

      this.iStopsTime += el.iStopsTime;

    })

  }

  analyze = async () => {

    $.confirm({

      title: `آیا از انجام این عملیات اطمینان دارید ؟`,

      content: 'با اجرای این فرمان، تحلیل های قبلی با مقدیر جدید جایگزین می شود',

      type: 'blue',

      buttons: {

        ok: {

          text: "تایید",

          btnClass: 'btn-primary',

          keys: ['enter'],

          action: async () => {

            let model = this.mdl_Search.value;

            this._other.Showspinner()

            let res = JSON.parse((await axios.post(`Transit_Trip_Analyze`, this._other.stringNumberToNumber(model))).data.toString());

            this._other.nonespinner();

            if (res.iResult == 0) return this._tooltip.showError(res.strError);

            this.lst_Reports = res;

            this.lst_Search = res;

            this.iTripTime = 0;

            this.iStops = 0;

            this.iStopsTime = 0;

            this.lst_Reports.forEach((el: any) => {

              this.iTripTime += el.iResultTime;

              this.iStops += el.iStops;

              this.iStopsTime += el.iStopsTime;

            })


          }

        },

        cancel: {

          text: "لغو",


        }

      }

    });

  }

  openRoute_Stops(item) {

    window.open(`/transit/route-stops/${item.iTransit_Trip}`, '_blank')
    
  }

  filter_list(val: any) {

    this.lst_Reports = this.lst_Search.filter((el: any) => {

      return el.strTitle.includes(val.value) ||

        el.strFullName.includes(val.value)

    });

    if (val.value.trim() == '') {

      this.lst_Reports = this.lst_Search;

    }

  }

}
